import Datetime from 'utils/datetime/datetime'
import { serializeDecimalInputText } from 'utils/numberUtils/decimalInput'
import type { BidSubmissionResponse } from '../IntradayTradingView.types'

type RowValues = Record<string, string>
type LatestCellValue = {
  timestampMs: number
  volume: number
  hourIndex: number
}

export const PREFILL_WINDOW_HOURS = 36

function getPrefillEndTime(startTime: Date): Date {
  const end = new Date(startTime)
  end.setHours(end.getHours() + PREFILL_WINDOW_HOURS)
  return end
}

export function getPrefillWindow(bidBaseStartTime: Date): { startTime: ISODateTime; endTime: ISODateTime } {
  return {
    startTime: Datetime.toISOString(bidBaseStartTime),
    endTime: Datetime.toISOString(getPrefillEndTime(bidBaseStartTime)),
  }
}

export function extractHourIndex(bidDatetime: ISODateTime, startTime: Date): number {
  const bidTime = new Date(bidDatetime)
  return Math.floor((bidTime.getTime() - startTime.getTime()) / (1000 * 60 * 60))
}

export function mapBidResponseToRowValues(response: BidSubmissionResponse, startTime: Date): RowValues[] {
  const result: RowValues[] = Array.from({ length: PREFILL_WINDOW_HOURS }, () => ({}))
  const latestByCell: Record<string, LatestCellValue> = {}

  for (const [positionId, bids] of Object.entries(response)) {
    for (const bid of bids) {
      if (bid.tag_id == null) continue

      const hourIndex = extractHourIndex(bid.bid_datetime, startTime)
      if (hourIndex < 0 || hourIndex >= PREFILL_WINDOW_HOURS) continue

      const cellKey = `${hourIndex}::${positionId}::${bid.tag_id}::${bid.direction}`
      const timestampMs = new Date(bid.bid_datetime).getTime()
      if (Number.isNaN(timestampMs)) continue

      const existing = latestByCell[cellKey]
      if (!existing || timestampMs > existing.timestampMs) {
        latestByCell[cellKey] = { timestampMs, volume: bid.volume, hourIndex }
      }
    }
  }

  Object.entries(latestByCell).forEach(([cellKey, latest]) => {
    if (latest.volume === 0) {
      return
    }
    result[latest.hourIndex][cellKey] = serializeDecimalInputText(latest.volume)
  })

  return result
}

export function countRowsThroughLastValue(rows: RowValues[], isConfiguredCell: (cellKey: string) => boolean): number {
  return rows.findLastIndex((row) => Object.keys(row).some(isConfiguredCell)) + 1
}
